import { api, RTKTags } from '@/store/api'

import Env from '../../../env/env'

import type { CreateWorkspaceRequest } from './CreateWorkspace.types'

export const createWorkspaceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createWorkspace: builder.mutation<void, CreateWorkspaceRequest>({
      query: (request) => ({
        url: `${Env.REACT_APP_BASE_API_URL}/api/v2/enterprises/workspaces`,
        method: 'POST',
        body: {
          name: request.name,
          teams: request.teams,
        },
      }),
      invalidatesTags: [
        RTKTags.createWorkspace,
        RTKTags.getWorkspaces,
        RTKTags.workspaceDetails,
      ],
    }),
  }),
})

export const { useCreateWorkspaceMutation } = createWorkspaceApi
